import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as MaterialModal } from '@material-ui/core';

import Button from 'src/components/Button/Button';

interface EndShiftModalInterface {
  onSubmit: () => Promise<void>,
  onClose: () => void
}

function EndShiftModal({ onSubmit, onClose }: EndShiftModalInterface) {
  const { t } = useTranslation();

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        <div className="cancel-ticket__modal">
          <h3 className="cancel-ticket__title">{ t('endShift.printerError') }</h3>
          <h3 className="cancel-ticket__subtitle">{
            `${ t('endShift.wantToEndIt') }`
          }</h3>
          <h3 className="cancel-ticket__subtitle">Session Id: { localStorage.getItem('tillSession') } </h3>
          <div className="cancel-ticket__buttons">
            <Button
              type="button"
              text={ t('endShift.endSession') }
              className="btn btn--cta"
              onClick={ onSubmit }
            />
            <Button
              type="button"
              text={ t('endShift.cancel') }
              className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
              onClick={ onClose }
            />
          </div>
        </div>
      </div>
    </MaterialModal>
  );
}

export default EndShiftModal;
